import React from 'react'

import * as S from './styles'

/**
 * @typedef {Object} SkeletonProps
 * @property {boolean} [visible]
 * @property {string | number} [height]
 * @property {string | number} [width]
 */

/**
 * @param {SkeletonProps} props 
 */
export default function Skeleton({ visible, height = 30, width }) {
  return <S.Skeleton width={width} height={height} visible={visible} />
}
